import state from './tag.state'
import mutations from './tag.mutations'
import actions from './tag.actions'

export default {
  state,
  mutations,
  actions
}
